import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { asSortParams } from "@dashboard/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  quotationListPath,
  QuotationListUrlQueryParams,
  QuotationListUrlSortField,
} from "./urls";
import QuotationListComponent from "./views/QuotationList/QuotationList";

const QuotationList = ({ location }: RouteComponentProps<any>) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: QuotationListUrlQueryParams = asSortParams(
    qs,
    QuotationListUrlSortField,
    QuotationListUrlSortField.date,
    false,
  );

  return <QuotationListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.quotations)} />
      <Switch>
        <Route exact path={quotationListPath} component={QuotationList} />
      </Switch>
    </>
  );
};

export default Component;